import { ImageManager } from './ImageManager';

const defaultImagesMap = {
  IMAGE_02:
    'https://leadcars.s3.eu-west-1.amazonaws.com/templates/config/img/acbae5eb-efa4-4eb6-866c-f421e740b713-ad3c92b1-9cdb-4a7b-aad3-75ad809db8a3.png',
  IMAGE_03:
    'https://leadcars.s3.eu-west-1.amazonaws.com/templates/config/img/98520d6c-5cef-449e-bcbf-6316ccec2088-e8780361-0deb-4896-895e-e690c886cdf0.png',
  IMAGE_04:
    'https://leadcars.s3.eu-west-1.amazonaws.com/templates/config/img/b064f705-34ba-4400-975e-9dd0cec21c30-cc9aa158-56bd-4bf1-b532-72390d25c864.png',
  IMAGE_59:
    '',
  IMAGE_09:
    'https://leadcars.s3.eu-west-1.amazonaws.com/templates/config/img/be34fb18-32ad-441c-84d8-3c0e9ba9f742-ad2ea5ff-5d0b-446b-bd7d-8e2ab5afdd16.png',
  IMAGE_10:
    'https://leadcars.s3.eu-west-1.amazonaws.com/templates/config/img/6a1e6292-469e-452a-bbae-44e4b5ff7463-05e543b6-c951-44ce-ae27-ca1282c77f52.png',
  IMAGE_15:
    'https://leadcars.s3.eu-west-1.amazonaws.com/templates/config/img/f69f48af-5b15-40aa-91c4-81d601d1357b-083dc99d-02a6-40d9-ae28-0662bd078b5d.png',
  IMAGE_16:
    'https://leadcars.s3.eu-west-1.amazonaws.com/templates/config/img/9cce6b16-5a98-4ddb-b1a1-6cec2cf56891-c3acb856-8ab8-4cfb-93f9-2a0747678b8b.png',
  IMAGE_17:
    'https://leadcars.s3.eu-west-1.amazonaws.com/templates/config/img/d9795c1d-fa32-4adb-ab25-30b7cfe87936-df21314f-6f05-4550-80b3-9ab1107e8fbe.png',
  IMAGE_31: 'https://leadcars.s3.eu-west-1.amazonaws.com/templates/config/img/hero1.jpg',

  DYNAMIC_IMAGE: 'https://leadcars.s3.eu-west-1.amazonaws.com/templates/config/img/dynamic-image-es.png',
  DYNAMIC_IMAGE_FULL: 'https://leadcars.s3.eu-west-1.amazonaws.com/templates/config/img/dynamic-image-es-full.png',
  DYNAMIC_IMAGE_PT: 'https://leadcars.s3.eu-west-1.amazonaws.com/templates/config/img/dynamic-image-pt.png',
  DYNAMIC_IMAGE_PT_FULL: 'https://leadcars.s3.eu-west-1.amazonaws.com/templates/config/img/dynamic-image-pt-full.png',
  DYNAMIC_IMAGE_IT: 'https://leadcars.s3.eu-west-1.amazonaws.com/templates/config/img/dynamic-image-it.png',
  DYNAMIC_IMAGE_IT_FULL: 'https://leadcars.s3.eu-west-1.amazonaws.com/templates/config/img/dynamic-image-it-full.png',


};

ImageManager.add(defaultImagesMap);
export function getImg(name: keyof typeof defaultImagesMap) {
  return ImageManager.get(name);
}
